import script from "./AddFactor.vue?vue&type=script&setup=true&lang=js"
export * from "./AddFactor.vue?vue&type=script&setup=true&lang=js"

import "./AddFactor.vue?vue&type=style&index=0&id=00dd133a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00dd133a"]])

export default __exports__